import { useState, useEffect, useCallback } from 'react';
import { TickerType, Timeframe } from '../types';
import { getTickerList } from 'services/client/getTickerList';

export const useCalendarData = () => {
  const [tickerData, setTickerData] = useState<TickerType[]>([]);
  const [selectedTicker, setSelectedTicker] = useState<TickerType | null>(null);
  const [searchResults, setSearchResults] = useState<TickerType[]>([]);
  const [dateValue, setDateValue] = useState('');
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);
  const [loading, setLoading] = useState(false);
  const [isWatchListOnly, setIsWatchListOnly] = useState(false);
  const [selectedTimeframe, setSelectedTimeframe] = useState<Timeframe>('Today');

  useEffect(() => {
    const fetchTickerData = async () => {
      if (!tickerData?.length) {
        try {
          const response = await getTickerList();
          setTickerData(response);
        } catch (error) {
          console.error('Failed to fetch ticker data:', error);
        }
      }
    };

    fetchTickerData();
  }, [tickerData]);

  const search = useCallback(
    (query: string) => {
      if (query.length >= 1) {
        const results = tickerData.filter(
          (ticker) =>
            ticker.t.toLowerCase().includes(query.toLowerCase()) ||
            ticker.n.toLowerCase().includes(query.toLowerCase()),
        );
        setSearchResults(results);
      } else {
        setSearchResults([]);
      }
    },
    [tickerData],
  );

  return {
    tickerData,
    selectedTicker,
    setSelectedTicker,
    searchResults,
    setSearchResults,
    dateValue,
    setDateValue,
    selectedDate,
    setSelectedDate,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    loading,
    setLoading,
    isWatchListOnly,
    setIsWatchListOnly,
    selectedTimeframe,
    setSelectedTimeframe,
    search,
  };
};
